<template>
  <div>
    <div v-if="loading_i" class="d-flex flex-column justify-content-center align-items-center pb-3"
      style="height: 93vh">
      <div class="content-container">

        <div class="icon-container">
          <i class="zmdi zmdi-spinner zmdi-hc-spin" style="font-size: 2rem"></i>
        </div>
        <p class="mt-3">Fetching data, please wait...</p>
      </div>
    </div>
    <div class="d-flex flex-row" v-if="ava_width > 768 && !loading_i">
      <marquee-text :repeat="text_repeat" :duration="custom_durationMRQ" :paused="isPaused"
        class=" mt-0 pb-1 box custom-col-md" @mouseenter="isPaused = !isPaused" @mouseleave="isPaused = false">
        <span v-for="station in stations" :key="station[0].id" style="font-size: 1.35rem">
          <span style="font-weight: 500" class="bwsTitle">
            {{ station[0].station_name }} &bull;
          </span>
          <span v-if="station[2]">
            <span v-for="(card, index) in [station[2]]" :key="index" class="flex mt-2" style="min-height: 12vh">
              <span v-for="(label, labelIndex) in card.running_label" :key="labelIndex" class="bwsTitle">
                {{ label }}: {{ card.running_data[labelIndex] }}
                {{ card.running_symbol[labelIndex] }}
                <span v-if="labelIndex !== card.running_label.length - 1">
                  |
                </span>
              </span>
            </span>
          </span>
          <img :src="logoPU" style="width: 20px" class="mx-3 my-1" />
        </span>
      </marquee-text>
    </div>

    <div v-if="!loading_i" class="row">
      <div class="col" :class="{ 'col-6 pr-0': ava_width > 768 }">
        <div class="row">
          <div class="col-12">
            <StationMap :balai="balai" :zoom="zoom" :center="center" :stations="stations" :status="status"
              :loading_i="loading_i" class="mx-auto mt-2 shadow-sm border" style="border-radius: 5px" />
          </div>
          <div class="col-12">
            <Stations :stations="stations" :loading_i="loading_i" class="shadow-sm border mt-2 "
              style="border-radius: 5px" />
          </div>
        </div>
      </div>
      <div class="col" :class="{ 'col-6 px-0': ava_width > 768 }">
        <Slider :ava_width="ava_width" :stations="stations" :currentIndex="currentIndex" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import StationMap from "@/components/Map/StationMap";
import Stations from "@/components/Map/Stations";
import MarqueeText from "@/components/MarqueeText.vue";
import logoPU from "@/assets/logo_pupr.svg";
import Slider from "@/components/Chart/Slider.vue";

export default {
  name: "Map",
  components: {
    StationMap,
    Stations,
    MarqueeText,
    Slider,

  },
  props: ["balai", "zoom", "center"],
  data() {
    return {
      isPaused: false,
      text_duration: null,
      text_repeat: null,
      custom_durationMRQ: null,
      showCarousel: true,
      ava_width: null,
      logoPU,
      msg: "Fetching data, please wait...",
      role: null,
      // balai: null,
      stations: [],
      marker: null,
      loading_i: true,
      status: [],
      currentIndex: 0,

    };
  },

  methods: {
    async homeData() {
      var st_name = [];
      var sensor = [];
      var st_name_length = null;
      var sensor_length = null;

      try {
        const response = await axios.get(
          `${this.$baseURL}/home-data/non-auth/${this.balai}`
        );
        this.stations = response.data.map((element) => {
          const x = element[1].chart.chart_sensor.flat().length;
          const duration = Math.ceil(x / 3) * 3 * 4000 + 1000;
          element.duration = duration;
          return element;
        });

        this.loading_i = false;

        response.data.forEach((e) => {
          st_name.push(e[0].station_name.length);
          sensor.push(
            e[1].table.array_table_label.reduce((a, b) => a + b, 0).length
          );

          var x =
            e[0].station_name.length +
            e[1].table.array_table_label.reduce((a, b) => a + b, 0).length;

          e.durationMRQ = x * 510;
        });

        st_name_length = st_name.reduce((a, b) => a + b, 0);
        sensor_length = sensor.reduce((a, b) => a + b, 0);

        this.custom_durationMRQ = (st_name_length + sensor_length) / 2;
        this.stations.slice(-1).pop().durationMRQ + 200;
// console.log(this.stations);

        if (response.status == 200) {
          this.loading_i = false;
        }

      } catch (error) {
        console.error("An error occurred:", error);
      }

    },
  },
  async created() {
    this.homeData();
  },
  mounted() {
    this.ava_width = screen.availWidth;
 
    
  },
};
</script>
